
export const BASE_URL = "https://us-central1-rcm-backend-c92c2.cloudfunctions.net/app/"
